import React, { Fragment } from 'react';
import {
  Dialog,
  DialogPanel,
  DialogTitle,
  Transition,
  TransitionChild,
} from '@headlessui/react';
import { X } from 'lucide-react';

interface SprintModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
  className?: string;
}

/** The dialog frame shared by the Sprint page's modals: backdrop, panel, title and close button. */
const SprintModal: React.FC<SprintModalProps> = ({
  isOpen,
  onClose,
  title,
  children,
  className = '',
}) => (
  <Transition appear show={isOpen} as={Fragment}>
    <Dialog as="div" className="relative z-[100]" onClose={onClose}>
      <TransitionChild
        as={Fragment}
        enter="ease-out duration-300"
        enterFrom="opacity-0"
        enterTo="opacity-100"
        leave="ease-in duration-200"
        leaveFrom="opacity-100"
        leaveTo="opacity-0"
      >
        <div className="fixed inset-0 bg-black/60 backdrop-blur-sm" />
      </TransitionChild>

      <div className="fixed inset-0 overflow-y-auto">
        <div className="flex min-h-full items-center justify-center p-4">
          <TransitionChild
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 scale-95"
            enterTo="opacity-100 scale-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 scale-100"
            leaveTo="opacity-0 scale-95"
          >
            <DialogPanel
              className={`w-full max-w-[440px] transform overflow-hidden rounded-2xl bg-[#131720] border border-[#232736] text-left shadow-2xl transition-all ${className}`}
            >
              <div className="flex items-center justify-between px-6 py-5 border-b border-[#1C1D26]">
                <DialogTitle as="h3" className="text-neutral text-[18px] font-bold">
                  {title}
                </DialogTitle>
                <button
                  type="button"
                  onClick={onClose}
                  className="text-neutral-medium hover:text-neutral transition-colors focus:outline-none"
                  aria-label="Close"
                >
                  <X size={20} />
                </button>
              </div>
              {children}
            </DialogPanel>
          </TransitionChild>
        </div>
      </div>
    </Dialog>
  </Transition>
);

export default SprintModal;
